import { defineMessages } from '../../i18n/messages';
import { englishText } from '../../utils/messageFallbacks';

const FOOTER_DEFINITIONS = {
  TAGLINE: {
    id: 'homepage.footer.tagline',
    text: 'LLM-powered translations that keep your variables intact. Delivered in minutes, with simple subscription plans.',
    description: 'Brand tagline shown below the logo in the footer. "LLM" stands for Large Language Model. Summarizes the product value proposition: AI translations, variable safety, speed, and simple pricing.',
  },
  SECTION_PRODUCT: {
    id: 'homepage.footer.section_product',
    text: 'Product',
    description: 'Footer column heading for product links',
  },
  LINK_PRICING: {
    id: 'homepage.footer.link_pricing',
    text: 'Pricing',
    description: 'Footer link to Pricing page',
  },
  LINK_USE_CASES: {
    id: 'homepage.footer.link_use_cases',
    text: 'Use Cases',
    description: 'Footer link to Use Cases page',
  },
  LINK_GET_STARTED: {
    id: 'homepage.footer.link_get_started',
    text: 'Get Started',
    description: 'Footer link to Get Started page',
  },
  SECTION_DEVELOPERS: {
    id: 'homepage.footer.section_developers',
    text: 'Developers',
    description: 'Footer column heading for developer links',
  },
  LINK_DOCUMENTATION: {
    id: 'homepage.footer.link_documentation',
    text: 'Documentation',
    description: 'Footer link to Documentation',
  },
  LINK_BLOG: {
    id: 'homepage.footer.link_blog',
    text: 'Blog',
    description: 'Footer link to the blog article index at /blog',
  },
  SECTION_SUPPORT: {
    id: 'homepage.footer.section_support',
    text: 'Support',
    description: 'Footer column heading for support links',
  },
  LINK_STATUS: {
    id: 'homepage.footer.link_status',
    text: 'Status',
    description: 'Footer link to Status page',
  },
  LINK_CONTACT: {
    id: 'homepage.footer.link_contact',
    text: 'Contact',
    description: 'Footer link to Contact page',
  },
  SECTION_COMPANY: {
    id: 'homepage.footer.section_company',
    text: 'Company',
    description: 'Footer column heading for company links',
  },
  LINK_ABOUT: {
    id: 'homepage.footer.link_about',
    text: 'About',
    description: 'Footer link to About page',
  },
  LINK_SECURITY: {
    id: 'homepage.footer.link_security',
    text: 'Security',
    description: 'Footer link to Security page',
  },
  LINK_PRIVACY: {
    id: 'homepage.footer.link_privacy',
    text: 'Privacy',
    description: 'Footer link to Privacy Policy page',
  },
  LINK_TERMS: {
    id: 'homepage.footer.link_terms',
    text: 'Terms',
    description: 'Footer link to Terms of Service page',
  },
  COPYRIGHT: {
    id: 'homepage.footer.copyright',
    text: '© {{year}} Localingos. All rights reserved.',
    description: 'Copyright notice in the footer. Uses {{year}} interpolation for current year.',
  },
};

export const FooterMessages = defineMessages(FOOTER_DEFINITIONS);

/** English fallbacks, used until `npm run i18n:extract` adds these ids to en-US.json. */
export const FooterText = englishText(FOOTER_DEFINITIONS);